import xior from "xior";

const API_URL = (
  process.env.NEXT_PUBLIC_API_URL ??
  "https://expert-tribble-rr4vx9gwj9jhx7xw-8080.app.github.dev"
).replace(/\/$/, "");

export const apiClient = xior.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json",
  },
  withCredentials: true
});
